function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ButtonGroup from 'react-bootstrap/es/ButtonGroup';
import cx from 'classnames';
import { includes } from 'lodash';
import Button from "../components/button";
import { showDeprecatedWarning } from "../utils/warnings";

var ButtonsRow =
/*#__PURE__*/
function (_Component) {
  _inherits(ButtonsRow, _Component);

  function ButtonsRow() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ButtonsRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ButtonsRow)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleButtonClick", function (index, element) {
      return function () {
        var onSelect = _this.props.onSelect;
        if (onSelect) onSelect(element, index);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "_renderChildElements", function () {
      var _this$props = _this.props,
          childElements = _this$props.childElements,
          selectedIndex = _this$props.selectedIndex,
          selectedIndexes = _this$props.selectedIndexes,
          variant = _this$props.variant,
          size = _this$props.size,
          disabled = _this$props.disabled,
          autoSetWidth = _this$props.autoSetWidth,
          multi = _this$props.multi;
      var buttonWidth = "".concat(100 / Math.max(1, childElements.length), "%");
      return childElements.map(function (element, index) {
        var _element$icon = element.icon,
            icon = _element$icon === void 0 ? null : _element$icon,
            _element$text = element.text,
            text = _element$text === void 0 ? null : _element$text,
            _element$id = element.id,
            id = _element$id === void 0 ? null : _element$id,
            _element$className = element.className,
            className = _element$className === void 0 ? null : _element$className;
        var buttonClass = cx({
          'ButtonsRow-active': multi ? includes(selectedIndexes, index) : index === selectedIndex
        }, className);
        var buttonProps = {
          type: 'button',
          className: buttonClass,
          style: autoSetWidth ? {
            width: buttonWidth
          } : null,
          variant: variant,
          size: size,
          disabled: disabled,
          onClick: _this.handleButtonClick(index, element)
        };
        if (id) buttonProps.id = id;
        return React.createElement(Button, _extends({
          key: index
        }, buttonProps), icon, React.createElement("div", {
          className: "ButtonsRow-text"
        }, text));
      });
    });

    return _this;
  }

  _createClass(ButtonsRow, [{
    key: "render",
    value: function render() {
      showDeprecatedWarning('ButtonsRow', 'ButtonGroup');
      var _this$props2 = this.props,
          className = _this$props2.className,
          size = _this$props2.size;
      return React.createElement(ButtonGroup, {
        size: size,
        className: cx('ButtonsRow', className)
      }, this._renderChildElements());
    }
  }]);

  return ButtonsRow;
}(Component);

_defineProperty(ButtonsRow, "propTypes", {
  /**
   * An array of objects containing: id and text, for example: [{ icon: <Chevron />, text: 'button text' }].
   *
   * These will be the buttons rendered
   */
  childElements: PropTypes.array.isRequired,

  /**
   * Overwrite the className
   */
  className: PropTypes.string,

  /**
   * On button select callback
   */
  onSelect: PropTypes.func,

  /**
   * Disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Selected button index by default
   */
  selectedIndex: PropTypes.number,

  /**
   * Selected indexes as an array
   */
  selectedIndexes: PropTypes.arrayOf(PropTypes.number),

  /**
   * - If false, width of each button inside relies on content of the button
   * - If true, width of each button will be 100% of width of ButtonsRow,
   *   divided by number of buttons
   */
  autoSetWidth: PropTypes.bool,

  /**
   * The theme of the buttons
   *
   * @see See [React Bootstrap's Button](https://react-bootstrap.github.io/components/buttons/)
   */
  variant: PropTypes.oneOf(['primary', 'outline-primary', 'secondary', 'outline-secondary', 'success', 'outline-success', 'warning', 'outline-warning', 'danger', 'outline-danger', 'info', 'outline-info', 'light', 'outline-light', 'dark', 'outline-dark', 'link']),

  /**
   * The size of the buttons
   *
   * @see See [React Bootstrap's Sizes](https://react-bootstrap.github.io/components/buttons/#sizes)
   */
  size: PropTypes.oneOf(['sm', 'lg']),

  /**
   * Enable to support multiple buttons
   */
  multi: PropTypes.bool
});

_defineProperty(ButtonsRow, "defaultProps", {
  variant: 'secondary',
  disabled: false,
  autoSetWidth: true,
  selectedIndexes: [],
  multi: false
});

ButtonsRow.displayName = 'ButtonsRow';
export default ButtonsRow;